import { Pipe, PipeTransform } from '@angular/core';
import { isMasked } from '@shared/utils/helpers/sanitizers';
import { getGlobalDateDisplayFormat } from '@shared/utils/helpers/user-preferences';
import moment from 'moment-timezone';

enum MomentTimeZoneDisplayFormats {
  timeToSeconds = 'timeToSeconds',
  timeWithDate = 'timeWithDate',
  timeWithJustMins = 'timeWithJustMins',
}

type MomentTimeZoneDisplayStrings = keyof typeof MomentTimeZoneDisplayFormats;

export const momentTimeZoneFormats = {
  timeToSeconds: getGlobalDateDisplayFormat('value') + ' HH:mm:ss z',
  timeWithDate: getGlobalDateDisplayFormat('value'),
  timeWithJustMins: 'HH:mm:ss z',
};
@Pipe({
  name: 'momentTimezone',
  standalone: false,
})
export class MomentTimezonePipe implements PipeTransform {
  transform(
    value: string | Date | moment.Moment,
    format: MomentTimeZoneDisplayStrings = MomentTimeZoneDisplayFormats.timeToSeconds
  ): string {
    const date = moment.isMoment(value) ? value : moment(value, ['MM/DD/YYYY HH:mm:ss z', 'YYYY-MM-DD HH:mm:ss z']);
    return isMasked(value)
      ? (value as string)
      : moment.tz(date, moment.tz.guess()).format(momentTimeZoneFormats[format] || momentTimeZoneFormats.timeToSeconds);
  }
}
